// @ts-ignore
import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Button, DialogFooter } from '../..';
import { useTranslation } from '@jobcost-monorepo/i18n';
import { memo } from 'react';

type Props = {
  isOpen: boolean;
  handleClose: () => void;
  children: React.ReactNode;
  handleFilter?: () => void;
  handleResetFilters?: () => void;
};

const FiltersForm: React.FC<Props> = ({
  isOpen,
  handleClose,
  children,
  handleFilter,
  handleResetFilters,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      as="div"
      className="relative z-50"
      onClose={handleClose}
      open={isOpen}
    >
      <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-0 md:pl-10">
        <Dialog.Panel className="pointer-events-auto w-screen md:max-w-sm h-[calc(100dvh)] md:h-screen content-center">
          <div className="flex flex-col bg-white shadow-2xl dark:bg-darkGrey dark:text-white dark:border dark:border-grey h-[calc(100dvh)]  md:h-[85%] md:mt-[6rem] md:mr-2 md:rounded-md">
            <div className="pt-6 px-6">
              <div className="flex items-start justify-between pb-5 border-b-2 border-purple/5 dark:border-grey50">
                <Dialog.Title className="text-xl font-semibold leading-6 text-gray-900">
                  {t('filters.title')}
                </Dialog.Title>
                <div className="ml-3 flex h-7 items-center">
                  <button
                    type="button"
                    className="relative rounded-md bg-white text-gray-400 hover:text-gray-500  dark:bg-transparent"
                    onClick={handleClose}
                  >
                    <span className="absolute -inset-2.5" />
                    <span className="sr-only">Close panel</span>
                    <XMarkIcon
                      className="h-6 w-6 stroke-purple dark:stroke-white"
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </div>
            </div>
            <div className="overflow-y-auto">{children}</div>
            <DialogFooter className="mt-auto p-6">
              <div className="flex justify-end items-end">
                <span className="w-5" />
                <Button
                  type="button"
                  className="bg-purple30 hover:bg-purple/20 hover:text-white"
                  onClick={handleResetFilters}
                >
                  {t('filters.clear')}
                </Button>
                <span className="w-5" />
                <Button type="button" onClick={handleFilter}>
                  {t('filters.filter')}
                </Button>
              </div>
            </DialogFooter>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};
export default memo(FiltersForm);
